import { Container, TooltipV2, Typography } from '@cleartrip/ct-design-components'
import { FC } from 'react'

interface FareCouponCalloutProps {
    isCouponPresentInAnyFare: boolean
    couponCallout: string
    compact?: boolean
}

const FareCouponCallout: FC<FareCouponCalloutProps> = ({ isCouponPresentInAnyFare, couponCallout, compact = false }) => {
    const styleConfig = {
        labelContainer: {
            css: {
                width: '100%'
            }
        },
        tooltipContainer: {
            css: {
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        tooltipArrowContainer: {
            css: {
                left: "20px"
            }
        }
    }

    return (
        <>
            {!compact && isCouponPresentInAnyFare && !couponCallout && <Container css={{ height: '36px' }} />}
            {couponCallout && (
                <TooltipV2
                    position={'bottom'}
                    labelContainer={
                        <Typography
                            variant="B3"
                            color="success"
                            className={`${compact ? '' : 'mt-1 '}t-truncate ta-right`}
                            lineClamp={2}
                            css={
                                compact
                                    ? { width: '100%', minWidth: 0 }
                                    : { minHeight: '32px', width: '100%', minWidth: 0 }
                            }
                        >
                            {couponCallout}
                        </Typography>
                    }
                    width={'100%'}
                    styleConfig={styleConfig}
                >
                    <Typography variant="B3" className="p-2 " css={{ color: 'white' }}>
                        {couponCallout}
                    </Typography>
                </TooltipV2>
            )}
        </>
    )
}

export default FareCouponCallout
